import React, { useState, useEffect } from 'react';
import { callingAPI } from '../config';
import Loader from '../Common/loader';
import Pagination from 'react-js-pagination';
import { useLocation } from "react-router-dom";

function PrescriptionAmountdetails(props) {
    const location = useLocation();

    const [prescriptionAmountDetailsArray, setPrescriptionAmountDetailsArray] = useState([]);
    const [doctorVisistMedicineTotalAmount, setDoctorVisistMedicineTotalAmount] = useState("");
    const [load, setLoad] = useState(false);
    const [totalCount, setTotalCount] = useState();
    const [activePage, setActivePage] = useState(1);
	const [pageOffset, setPageOffset] = useState(0);
    const [isData, setIsData] = useState(0);
    const [prescriptionAmountDetails, setPrescriptionAmountDetails] = useState([]);

    useEffect(() => {
        const PostData = {
            userId: window.sessionStorage.getItem('userId'),
            role: window.sessionStorage.getItem('role'),
            doctorId: location.state.data,
            fromDate: location.state.fDate && location.state.fDate != "NaN-NaN-NaN" ? location.state.fDate : "",
            toDate: location.state.tDate && location.state.tDate != "NaN-NaN-NaN" ? location.state.tDate : "",
            max: process.env.REACT_APP_PAGINATION_COUNT,
			offset: pageOffset,
        };
        callingAPI('reports/prescriptionAmountDetails', PostData)
            .then((data) => {
                console.log("listData",data)
                setPrescriptionAmountDetailsArray(data.data.result.prescriptionAmountDetailsArray);
                setDoctorVisistMedicineTotalAmount(
                    data.data.result.totalAmount
                );
                setLoad(true)
                setTotalCount(data.data.result.totalCount);

            })
            .catch();
    }, []);

    const handlePagination = (pageNumber) => {
		setActivePage(pageNumber);
		var offset;
		var max;
		if (pageNumber === '1') {
			offset = '0';
			max = process.env.REACT_APP_PAGINATION_COUNT;
		} else {
			offset = parseInt(pageNumber - 1) * process.env.REACT_APP_PAGINATION_COUNT;
			max = process.env.REACT_APP_PAGINATION_COUNT;
		}
		setActivePage(pageNumber);
		setPageOffset(offset);
		let PostData = {
			userId: window.sessionStorage.getItem('userId'),
			role: window.sessionStorage.getItem('role'),
			max: max,
			offset: offset,
            doctorId: location.state.data,
            fromDate: location.state.fDate && location.state.fDate != "NaN-NaN-NaN" ? location.state.fDate : "",
            toDate: location.state.tDate && location.state.tDate != "NaN-NaN-NaN" ? location.state.tDate : ""
		};
		callingAPI('reports/prescriptionAmountDetails', PostData)
			.then((data) => {
				if (data.data.success === '1') {
					setPrescriptionAmountDetails(data.data.result.prescriptionAmountDetailsArray);
					setTotalCount(data.data.result.totalCount);
					setIsData(1);
				}
			})
			.catch();
	};
    return (
        <div className="dashboardCover">
            <div className="breadcrumbDoc">
                <ul>
                    <li>
                        <a href="/reports/prescriptionAmount" className="blueLink">
                            Prescription(s) Amount
                        </a>
                    </li>{' '}
                    <div className="arrow-right" />
                    <li> Prescription(s) Amount Details </li>
                </ul>
            </div>
            <div className="dashboardTitle">Prescription(s) Amount Details</div>
            <div className="paginationSection">
            {totalCount > 10 && (
					<div className="paginationSection">
						<Pagination
							// hideNavigation
							activePage={activePage}
							itemsCountPerPage={process.env.REACT_APP_PAGINATION_COUNT}
							totalItemsCount={totalCount}
							pageRangeDisplayed={process.env.REACT_APP_PAGINATION_RANGE}
							onChange={handlePagination}
						/>
					</div>
				 )}
				</div>
            <div className="dashboardContent">
                {load === false ? <Loader /> : ''}
                <div className="reportWrap">
                    <div className="dashboardSearch" style={{ background: 'transparent' }}>
                        <div className="row">
                            <div className="col-md-12 dashboardSearchList">
                                <div className="searchCount">
                                    <b>Total Amount :
                                        &#8377; {doctorVisistMedicineTotalAmount === "" ? "0.00" : doctorVisistMedicineTotalAmount.toFixed(2)}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dashboardtable">
                        <table className="PrescriptionAmnt">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Medicine Name</th>
                                    <th>Quantity</th>
                                    <th style={{ textAlign: 'right' }}> Price</th>
                                    {/* <th>Instructions of taking Medicine</th> */}

                                    <th style={{ textAlign: 'right' }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {prescriptionAmountDetailsArray.map(data => (
                                    <tr>
                                        <td>{data.prescribedMedicineDate}</td>

                                        <td>
                                            {data.prescribedMedicineDetails.map(item => (
                                                <div>	{item.medicineName}</div>
                                            ))}</td>

                                        <td>{data.prescribedMedicineDetails.map(item => (
                                            <div> {item.totalQty}</div>
                                        ))}</td>
                                        <td style={{ textAlign: 'right' }}>
                                            {data.prescribedMedicineDetails.map(item => (

                                                <div> &#8377; {item.price == "" ? item.price : parseFloat(item.price.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>

                                            ))}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>{data.prescribedMedicineDetails.map(item => (

                                            <div>&#8377; {parseFloat(item.totalAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                                            // <div>&#8377; {item.totalAmount}</div>

                                        ))}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="paginationSection">
            {totalCount > 10 && (
					<div className="paginationSection">
						<Pagination
							// hideNavigation
							activePage={activePage}
							itemsCountPerPage={process.env.REACT_APP_PAGINATION_COUNT}
							totalItemsCount={totalCount}
							pageRangeDisplayed={process.env.REACT_APP_PAGINATION_RANGE}
							onChange={handlePagination}
						/>
					</div>
				 )}
				</div>

        </div>
    );
}
export default PrescriptionAmountdetails;
